interface EmptyStateProps {
  title: string;
  description?: string;
  actionLabel?: string;
  onAction?: () => void;
  icon?: string;
}

export default function EmptyState({ title, description, actionLabel, onAction, icon = 'ri-inbox-line' }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center text-center py-16 px-4 bg-background-50 border border-background-200 rounded-lg">
      <span className="w-16 h-16 rounded-full bg-background-100 text-foreground-400 flex items-center justify-center mb-4">
        <i className={`${icon} text-3xl`}></i>
      </span>
      <p className="font-heading text-lg font-bold text-foreground-900">{title}</p>
      {description ? <p className="mt-2 text-sm text-foreground-600 max-w-md">{description}</p> : null}
      {actionLabel && onAction ? (
        <button
          type="button"
          onClick={onAction}
          className="mt-5 inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-accent-500 text-background-50 dark:text-foreground-950 text-sm font-label font-medium hover:bg-accent-600 transition-colors cursor-pointer whitespace-nowrap"
        >
          <i className="ri-refresh-line"></i>
          {actionLabel}
        </button>
      ) : null}
    </div>
  );
}